// extracted by mini-css-extract-plugin
export var checkbox = "_3n-0";
export var circle = "_3n-3";
export var horizontalContainer = "_3n-7";
export var sm = "_3n-5";
export var switch0 = "_3n-2";
export var switchDisabled = "_3n-8";
export var switchEnabled = "_3n-1";
export var textSwitchContainer = "_3n-9";
export var textSwitchOption = "_3n-a";
export var textSwitchOptionSelected = "_3n-b";
export var verticalContainer = "_3n-6";
export var xs = "_3n-4";